<div
  class="arpio-banner"
  [class.arpio-banner--info]="variant === 'info'"
  [class.arpio-banner--success]="variant === 'success'"
  [class.arpio-banner--warning]="variant === 'warning'"
  [class.arpio-banner--stale]="variant === 'stale'"
  [class.arpio-banner--critical]="variant === 'critical'"
  [attr.role]="variant === 'critical' || variant === 'warning' ? 'alert' : 'status'"
>
  <span class="arpio-banner__chip">
    @switch (variant) {
      @case ('success') {
        <svg lucideCircleCheck></svg>
      }
      @case ('warning') {
        <svg lucideCircleAlert></svg>
      }
      @case ('critical') {
        <svg lucideCircleAlert></svg>
      }
      @default {
        <svg lucideInfo></svg>
      }
    }
  </span>
  <span class="arpio-banner__body">
    <ng-content></ng-content>
  </span>
  <span class="arpio-banner__action"><ng-content select="[banner-action]"></ng-content></span>
  @if (dismissible) {
    <button type="button" class="arpio-banner__dismiss" (click)="onDismiss()" aria-label="Dismiss">
      <svg lucideX></svg>
    </button>
  }
</div>
